/* eslint no-useless-escape: 0 */

'use strict';

export default {
  methods: {
    // getRoles (filter) {
    //   this.$service.graphql({
    //     query: `
    //       query getRoles {
    //         roles {
    //           count
    //           rows {
    //             id
    //             nombre
    //             descripcion
    //           }
    //         }
    //       }
    //     `,
    //     variables: {}
    //   }).then(response => {
    //     if (response) {
    //       let items = response.roles.rows;
    //       let roles = [];
    //       items.map(rol => {
    //         roles.push({ value: rol.id, text: rol.nombre + ' - ' + rol.descripcion });
    //       });
    //       this.roles = roles;
    //       if (filter && this.filters[filter] && this.filters[filter].items) {
    //         this.filters[filter].items = this.roles;
    //       }
    //     }
    //   });
    // },
    getRegionales (filter) {
      this.$service.graphql({
        query: `
          query getRegionales {
            parametroBuscar(name: "REGIONALES") {
              valor
            }
          }
        `,
        variables: {}
      }).then(response => {
        if (response && response.parametroBuscar) {
          this.regionales = response.parametroBuscar.valor.split(',');
          if (filter && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.regionales;
          }
        }
      });
    }
    // getEntidades (filter) {
    //   this.$service.graphql({
    //     query: `
    //       query getEntidades($estado: EstadoEntidad) {
    //         entidades(estado: $estado) {
    //           count
    //           rows {
    //             id
    //             nombre
    //             sigla
    //           }
    //         }
    //       }
    //     `,
    //     variables: {
    //       estado: 'ACTIVO'
    //     }
    //   }).then(response => {
    //     if (response) {
    //       let items = response.entidades.rows;
    //       let entidades = [];
    //       items.map(est => {
    //         entidades.push({ value: est.id, text: (est.sigla ? `${est.sigla} - ` : '') + est.nombre });
    //       });
    //       this.entidades = entidades;
    //       if (filter && this.filters[filter] && this.filters[filter].items) {
    //         this.filters[filter].items = this.entidades;
    //       }
    //     }
    //   });
    // }
  }
};



// WEBPACK FOOTER //
// ./src/components/admin/auxiliar/mixins/auxiliar.js